<template>
  <div class="myIssue">
    <div class="myissue_header van-hairline--bottom">
      <div
        :class="showIndex == item.index ? 'item active' : 'item'"
        v-for="item in items"
        :key="item.id"
        @click="sclectIndex(item.index)"
      >
        {{ item.name }}
      </div>
    </div>
    <van-empty v-if="list.length == 0" description="暂无数据" />
    <div class="container" v-else>
      <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="item"
          v-for="(item, index) in list"
          :key="index"
          @click="gopage(item)"
        >
          <div class="item_left line2">
            {{ item.ArticleTitle || item.video_name }}
          </div>
          <div class="item_right">
            <div class="img_box">
              <img :src="item.ArticleImage || item.video_cover" />
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getRelease, getReleaseVideo } from "@/api/lcapi";
import { List, Empty } from "vant";
export default {
  name: "MyIssue",
  components: {
    [Empty.name]: Empty,
    [List.name]: List
  },
  data() {
    return {
      items: [
        { name: "文章", index: 0 },
        { name: "视频", index: 1 }
        // { name: "专题", index: 2 },
      ], // 头部列表
      showIndex: 0, // 选择状态
      list: "",
      limit: 10, // 分页数
      total: "", // 总数
      error: false,
      loading: false,
      finished: false
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    /**
     * nav导航切换
     */
    sclectIndex(index) {
      if (index != this.showIndex) {
        this.showIndex = index;
        this.limit = 10;
        this.list = [];
        this.onLoad();
      }
    },
    /**
     * 跳转详情
     */
    gopage(item) {
      if (this.showIndex == 0) {
        this.$router.push({
          path: "/jiaodian/imgtextDetail",
          query: { id: item.ArticleId }
        });
      } else if (this.showIndex == 1) {
        this.$router.push({
          path: "/video/index",
          query: { id: item.id }
        });
      }
    },
    onLoad() {
      const that = this;
      if (this.showIndex == 0) {
        getRelease({ page: 1, limit: that.limit })
          .then(res => {
            that.total = res.data.total;
            that.list = res.data.data;
            // 加载状态结束
            that.loading = false;
            that.limit = that.limit + 10;
            // 数据全部加载完成
            if (that.list.length >= that.total) {
              that.finished = true;
            }
          })
          .catch(err => {
            that.loading = false;
            that.error = true;
          });
      } else {
        getReleaseVideo({ page: 1, limit: that.limit })
          .then(res => {
            that.total = res.data.total;
            that.list = res.data.list;
            // 加载状态结束
            that.loading = false;
            that.limit = that.limit + 10;
            // 数据全部加载完成
            if (that.list.length >= that.total) {
              that.finished = true;
            }
          })
          .catch(err => {
            that.loading = false;
            that.error = true;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.myIssue {
  padding-top: 1rem;
  .myissue_header {
    display: flex;
    justify-content: flex-start;
    background: #ffffff;
    line-height: 0.8rem;
    padding: 0 0.3rem;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 9999;
    .item {
      font-weight: bold;
      font-size: 0.3rem;
      min-width: 1rem;
      color: #999999;
      &.active {
        color: #ff410a;
      }
    }
  }
  .container {
    .list {
      margin-top: 0.2rem;
      .item {
        min-height: 1rem;
        padding: 0.2rem 0.3rem 0.2rem 0;
        background: #ffffff;
        display: flex;
        justify-content: space-between;
        border-bottom: 0.01rem solid #e9e9e9;
        &:last-child {
          border-bottom: 0;
        }
        .item_left {
          flex: 1;
          width: calc(100% - 1.5rem);
          padding: 0 0.3rem;
        }
        .item_right {
          font-size: 0;
          text-align: right;
          .img_box {
            width: 1.5rem;
            overflow: hidden;
            height: 1rem;
            border-radius: 0.05rem;
            border: 0.01rem solid #e9e9e9;
            font-size: 0;
            img,
            video {
              width: 100%;
              height: 100%;
            }
          }
          .hot {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            height: 0.4rem;
          }
        }
      }
    }
    .noData {
      text-align: center;
      font-size: 0.24rem;
      margin-top: 0.36rem;
      color: #999999;
    }
  }
}
</style>
